import { useMutation, useQueryClient } from "@tanstack/react-query";
import { http } from "../../utils";

async function postStatusAction({ action, productOrderId }) {
  const data = await http(`/admin/product-orders/${productOrderId}/status`, {
    method: "PATCH",
    data: {
      action,
    },
  });
  return data;
}

export function usePostStatusAction() {
  const queryClient = useQueryClient();

  return useMutation(postStatusAction, {
    onSuccess: () => {
      queryClient.refetchQueries(["product-order-parents"]);
    },
  });
}
